module.exports = __webpack_public_path__ + "img/zlecenia.cd44007d.svg";